<template>
    <li :class="searchStr.length > 2 ? 'm-dropdown--open' : ''" class="m-nav__item m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width m-dropdown--skin-light	m-list-search m-list-search--skin-light" data-dropdown-toggle="click" data-dropdown-persistent="true" id="m_quicksearch" data-search-type="dropdown">
        <a href="#" class="m-nav__link m-dropdown__toggle">
            <span class="m-nav__link-icon">
                <i class="flaticon-search-1"></i>
            </span>
        </a>
        <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--center"></span>
            <div class="m-dropdown__inner ">
                <div class="m-dropdown__header">
                    <form  class="m-list-search__form">
                        <div class="m-list-search__form-wrapper">
                            <span class="m-list-search__form-input-wrapper">
                                <input v-model="searchStr" @keyup="search()" id="profo-search" autocomplete="off" type="text" class="m-list-search__form-input" placeholder="Suche...">
                            </span>
                            <span class="m-list-search__form-icon-close" id="m_quicksearch_close">
                                <i class="la la-remove"></i>
                            </span>
                        </div>
                    </form>
                </div>
                <div>
                    <div class="m-dropdown__scrollable m-scrollable" data-scrollable="true" data-max-height="300" data-mobile-max-height="200">
                        <div class="m-dropdown__content">
                            <div class="quick-search-result">

                                <div v-for="client in searchArr" class="mb-10">
                                    <div class="d-flex align-items-center flex-grow-1 mb-2">
                                        <div class="d-flex flex-column ml-3 mt-2 mb-2">
                                            <a :href="'/kunde-' + client.id" class="font-weight-bold text-dark text-hover-primary mb-3">
                                                <b class="text-primary">{{ client.id }}</b> - <b v-if="client.company != ''">{{ client.company }}</b>   <span class="text-info">{{ client.prename }} {{ client.name }}</span>
                                            </a>
                                            <a v-for="project in client.projects.slice(0, 5)" :key="'search-pro-' + project.id" :href="'projekt-' + project.id" class="font-size-sm font-weight-bold text-muted mb-2">{{ project.client_project_count }} - {{ project.name }} ({{ project.created_at }})</a>
                                        </div>
                                    </div>
                                </div>
                                <!--end::Section-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'profo-search',

    data() {
        return {
            "searchArr": [],
            "searchStr": ""
        }
    },

    methods: {
        search(){
            let them = this;

            if (this.searchStr.length > 2){
                $.ajax({
                    url :'/profo-search',
                    type: "GET",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { searchStr: them.searchStr },
                    success:  (data) => {
                        this.searchArr = JSON.parse(data);
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            }
        }
    }
}
</script>
